export enum DirectoryGroupType{
    Security = "Security",
    // Microsoft365 = "Microsoft365"
}